import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VCard,{attrs:{"loading":false}},[_c(VOverlay,{attrs:{"absolute":true,"value":_vm.isComponentLoading}},[_c(VProgressCircular,{attrs:{"indeterminate":"","size":"24"}})],1),_c(VRow,{staticClass:"pa-3"},[_c(VCol,{attrs:{"cols":"12","md":"12"}},[_c(VTextField,{attrs:{"hint":_vm.$t('hints.searchByPhone'),"persistent-hint":"","single-line":"","loading":false},model:{value:(_vm.searchParams.search_contact),callback:function ($$v) {_vm.$set(_vm.searchParams, "search_contact", $$v)},expression:"searchParams.search_contact"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }